module.exports = __webpack_public_path__ + "images/findCareImage_f381c80.svg";